import React from 'react';
import { Rate } from 'antd';
import { useTranslation } from 'react-i18next';

// 用户评分：新用户 users.rating 默认 5.00，没有评价时显示「暂无评价」而非满星，免得误导对方。
// reviewCount 未知（接口没返回）时按原样显示星级。
const UserRating = ({ rating, reviewCount, size = 12, showValue = true }) => {
  const { t } = useTranslation('widgets');
  if (reviewCount === 0) {
    return <span style={{ fontSize: size, color: '#999' }}>{t('rating.none')}</span>;
  }
  const value = Number(rating) || 0;
  return (
    <span>
      <Rate disabled allowHalf value={value} style={{ fontSize: size }} />
      {showValue && (
        <span style={{ fontSize: size, color: '#666', marginLeft: 6 }}>
          {reviewCount ? t('rating.withCount', { value: value.toFixed(2), count: reviewCount }) : t('rating.valueOnly', { value: value.toFixed(2) })}
        </span>
      )}
    </span>
  );
};

export default UserRating;
